import FullWidth from './FullWidth';
import Narrow from './Narrow';

export {
	FullWidth,
	Narrow
}